import Xinstall from './Xinstall';

export default new Xinstall(process.env.VUE_APP_XINSTALL);
